export const FETCHED_TAGS = 'FETCHED_TAGS';
export const FETCHED_TAG = 'FETCHED_TAG';
export const CREATED_TAG = 'CREATED_TAG';
export const UPDATED_TAG = 'UPDATED_TAG';
export const DELETED_TAG = 'DELETED_TAG';
export const FETCHED_VOCABULARIES = 'FETCHED_VOCABULARIES';
export const FETCHED_VOCABULARY_LEVELS = 'FETCHED_VOCABULARY_LEVELS';
export const FETCHED_TAG_PARENTS = 'FETCHED_TAG_PARENTS';
export const SELECTED_VOCABULARY_ID = 'SELECTED_VOCABULARY_ID';
export const SELECTED_LEVEL = 'SELECTED_LEVEL';
export const SELECTED_PARENT_TAG = 'SELECTED_PARENT_TAG';
export const SELECTED_TAG_NAME = 'SELECTED_TAG_NAME';
export const SELECTED_TAGOS_ID = 'SELECTED_TAGOS_ID';
export const CLEAR_FORM_FIELDS = 'CLEAR_FORM_FIELDS';
export const FETCHED_TAG_TRANSLATIONS = 'FETCHED_TAG_TRANSLATIONS';
export const FETCHED_TAG_TRANSLATION = 'FETCHED_TAG_TRANSLATION';
export const DELETED_TAG_TRANSLATION = 'DELETED_TAG_TRANSLATION';
export const EDIT_TEXT_FIELD_INLINE = 'EDIT_TEXT_FIELD_INLINE';
export const ADD_TEXT_FIELD_INLINE = 'ADD_TEXT_FIELD_INLINE';
export const GET_TRANSLATION_FOR_SITE = 'GET_TRANSLATION_FOR_SITE';


// WEBPACK FOOTER //
// ./src/containers/tags/types.js